import React, { Component } from 'react'

class Disclaimer extends Component {

    render() {
        return <div id="disclaimer" className="flex-centered">
            <i className="fas fa-exclamation-circle"></i>
            <div>
                {this.props.content}
            </div>
        </div>
    }
}

export default Disclaimer